import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cell-actionevent',
  templateUrl: './cell-actionevent.component.html',
  styleUrls: ['./cell-actionevent.component.css']
})
export class CellActionEventComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  agInit(params: any): void {
    params.component;

  }

}
